<!--
 * @Description:
 * @Autor: Zhongyu
 * @Date: 2022-02-15 10:13:45
 * @LastEditors: wan neng 474140298@qq.com
 * @LastEditTime: 2022-06-15 16:15:55
-->
<template>
  <div class="route-details">
    <div id="routeDetailsMap" class="route-details-map"></div>
    <div class="route-details-body">
      <img
        class="back"
        src="../../assets/img-back.png"
        @click="$router.back(-1)"
      />
      <div class="left">
        <box :width="359" :height="891">
          <div class="overflow-box">
            <div class="start-end">
              <a-timeline mode="left">
                <a-timeline-item>
                  <div>起始点</div>
                  <div
                    v-if="pathParams && pathParams.length > 0"
                    class="address start"
                  >
                    {{ pathParams[0].name }}
                  </div>
                  <div v-else class="address start">
                    -
                  </div>
                </a-timeline-item>
                <a-timeline-item>
                  <div>结束位置</div>
                  <div
                    v-if="pathParams && pathParams.length > 0"
                    class="address end"
                  >
                    {{ pathParams[pathParams.length - 1].name }}
                  </div>
                  <div v-else class="address start">
                    -
                  </div>
                </a-timeline-item>
              </a-timeline>
            </div>
            <div class="car-route">
              <a-timeline mode="left">
                <a-timeline-item v-for="item in pathParams" :key="item.id">
                  {{ item.name }}
                </a-timeline-item>
              </a-timeline>
            </div>

            <div v-if="returnPathParams.length" class="back-title">返回</div>

            <div v-if="returnPathParams.length" class="start-end">
              <a-timeline mode="left">
                <a-timeline-item>
                  <div>起始点</div>
                  <div
                    v-if="returnPathParams && returnPathParams.length > 0"
                    class="address start"
                  >
                    {{ returnPathParams[0].name }}
                  </div>
                  <div v-else class="address start">
                    -
                  </div>
                </a-timeline-item>
                <a-timeline-item>
                  <div>结束位置</div>
                  <div
                    v-if="returnPathParams && returnPathParams.length > 0"
                    class="address end"
                  >
                    {{ returnPathParams[returnPathParams.length - 1].name }}
                  </div>
                  <div v-else class="address start">
                    -
                  </div>
                </a-timeline-item>
              </a-timeline>
            </div>
            <div v-if="returnPathParams.length" class="car-route">
              <a-timeline mode="left">
                <a-timeline-item
                  v-for="item in returnPathParams"
                  :key="item.id"
                >
                  {{ item.name }}
                </a-timeline-item>
              </a-timeline>
            </div>
          </div>
        </box>
      </div>
      <div class="right">
        <box :width="760" :height="891">
          <div class="right-body">
            <div class="right-body-hander">
              <div class="hander-left">
                <a-icon type="unordered-list" />
                <span>行驶记录</span>
              </div>
              <div class="hander-right">
                <div class="form">
                  <div class="form-item">
                    <label>车牌号:</label>
                    <a-input
                      v-model="params.numberPlate"
                      placeholder="请输入"
                    ></a-input>
                  </div>
                  <div class="form-item">
                    <label>司机:</label>
                    <a-input
                      v-model="params.driverName"
                      placeholder="请输入"
                    ></a-input>
                  </div>
                  <div class="form-item">
                    <label>时间:</label>
                    <a-range-picker
                      v-model="params.date"
                      dropdown-class-name="default-range-picker-dropdown"
                    />
                  </div>
                  <div class="form-item">
                    <a-config-provider :auto-insert-space-in-button="false">
                      <a-button type="primary" @click="handlerSumbit">
                        查询
                      </a-button>
                    </a-config-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-body-table">
              <a-table
                class="default-table"
                :columns="columns"
                :data-source="data"
                :pagination="false"
                :locale="{ emptyText: '暂无数据' }"
                row-key="id"
              >
                <span slot="diverState" slot-scope="text">
                  <span v-if="text == 0" class="green">
                    进行中
                  </span>
                  <span v-if="text != 0" class="red">
                    已完成
                  </span>
                </span>
                <span
                  slot="action"
                  slot-scope="text, record"
                  class="operation-action"
                >
                  <span
                    class="operation blue"
                    @click="handleTableDatails(record)"
                  >
                    <span class="iconfont icon-bianji"></span>
                    查看
                  </span>
                </span>
              </a-table>
            </div>
            <div class="right-body-pagination">
              <pagination
                ref="pagination"
                :total="total"
                @change="handlerPaginationChange"
              ></pagination>
            </div>
          </div>
        </box>
      </div>
    </div>
  </div>
</template>

<script>
import Box from "@/components/Box";
import Pagination from "@/components/Pagination";
import AMap from "AMap";
import moment from "moment";

const columns = [
  {
    title: "车辆",
    dataIndex: "numberPlate",
    key: "numberPlate"
  },
  {
    title: "司机",
    dataIndex: "driverName",
    key: "driverName"
  },
  {
    title: "行驶时间",
    dataIndex: "startTime",
    key: "startTime"
  },
  {
    title: "状态",
    dataIndex: "diverState",
    key: "diverState",
    scopedSlots: { customRender: "diverState" }
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  components: {
    Box,
    Pagination
  },
  data() {
    return {
      select: 1,
      map: null,
      data: [],
      columns,
      params: {
        num: 10,
        page: 1,
        // routeId: "",
        driverName: "",
        numberPlate: "",
        end: undefined,
        start: undefined,
        date: []
      },
      pathParams: [],
      returnPathParams: [],
      total: 0
    };
  },
  mounted() {
    if (this.$route.query.type == 3) {
      this.params.rentId = this.$route.query.id;
    } else {
      this.params.routeId = this.$route.query.id;
    }
    this.initMap();
    this.getShiftLineDetails();
    this.$store.dispatch("setButtonStatus", 0);
  },
  methods: {
    initMap() {
      let map = new AMap.Map("routeDetailsMap", {
        resizeEnable: true, //自适应大小
        zoom: 13, //初始视窗
        scrollWheel: false,
        viewMode: "3D",
        mapStyle: "amap://styles/48973c04a03806fd9a451891d922af47" //设置地图的显示样式
      });
      this.map = map;
    },
    getShiftLineDetails() {
      let params = { ...this.params };
      console.log(params.date);
      if (params.date.length) {
        params.end = moment(params.date[1]).format("YYYY-MM-DD");
        params.start = moment(params.date[0]).format("YYYY-MM-DD");
      }
      delete params.date;
      if (this.$route.query.type == 3) {
        this.$api.list.getRentList(params).then(res => {
          let { Route, drivingRecordList, total } = res.data;
          this.data = drivingRecordList;
          this.total = total || 0;
          this.pathParams = Route.toBRouteSites;
          this.returnPathParams = Route.returnBRouteSites;
          this.drawLine(Route);
        });
      } else {
        this.$api.list.getShiftLineDetails(params).then(res => {
          let { Route, drivingRecordList, total } = res.data;
          this.data = drivingRecordList;
          this.total = total || 0;
          this.pathParams = Route.toBRouteSites;
          this.returnPathParams = Route.returnBRouteSites;
          this.drawLine(Route);
        });
      }
    },
    drawLine(routeList) {
      let pathParams = [];
      routeList.toBRouteSites.map(item => {
        pathParams.push([item.lon, item.lat]);
      });

      let map = this.map;

      let markerList = [];
      for (let i = 0; i < pathParams.length; i++) {
        const points = pathParams[i];
        let icon = require("../../assets/img-map-point-icon.png");
        if (i == 0) {
          icon = require("../../assets/img-map-start-icon.png");
        } else if (i == pathParams.length - 1) {
          icon = require("../../assets/img-map-end-icon.png");
        }

        let endMarker = new AMap.Marker({
          icon: icon,
          position: points,
          map: map
        });
        markerList.push(endMarker);
      }

      map.add(markerList);

      AMap.plugin("AMap.Driving", function() {
        var driving = new AMap.Driving({
          map: map,
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME 最快捷模式
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_FEE 最经济模式
          // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_DISTANCE 最短距离模式
          // 驾车路线规划策略，AMap.DrivingPolicy.REAL_TRAFFIC 考虑实时路况
          policy: AMap.DrivingPolicy.LEAST_FEE,
          hideMarkers: true,
          showTraffic: true,
          isOutline: false,
          outlineColor: "#16ce5a",
          autoFitView: true
        });
        let waypoints = pathParams;
        driving.search(pathParams[0], pathParams[pathParams.length - 1], {
          waypoints: waypoints
        });
      });
      // //  显示缩放加减号
      // // eslint-disable-next-line no-undef
      // AMap.plugin(["AMap.ControlBar"], function() {
      //   // 添加 3D 罗盘控制
      //   // eslint-disable-next-line no-undef
      //   map.addControl(new AMap.ControlBar());
      // });
    },
    handlerSumbit() {
      this.params.page = 1;
      this.$refs.pagination.setData(this.params.page, this.params.num);
      this.getShiftLineDetails();
    },
    handlerPaginationChange(page, size) {
      this.params.page = page;
      this.params.num = size;
      this.getShiftLineDetails();
    },

    heandleClickMenu(item) {
      this.select = item.id;
      if (this.$route.path != item.url) {
        this.$router.push(item.url);
      }
    },
    handleTableDatails(record) {
      this.$router.push(`/car-detail?id=${record.id}&type=1`);
    }
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
